export const returnWarehouseCategoryOptions = (categories, addAll = true) => {
    if (addAll) {
        categories = [{
            label: "All",
            value: "all"
        }].concat(categories);
    }
    return categories;
};